import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { PanelResult } from "common/panel/dto/PanelResult";
import { NavLink } from "react-router-dom";
import { useSakusasPanelDelete } from "hooks/sakusas/panel/useSakusasPanelDelete";
import { QUERY_KEYS } from "constant/react_query";
import { panelLinkSingle } from "common/panel/panel_link_common";
import useConfirm from "common/modal/ConfirmDialog";

type PanelSingleNavProps = {
  panel: PanelResult;
  hideEditNav?: boolean;
  hideReadNav?: boolean;
  hideDeleteNav?: boolean;
};

const PanelSingleNav = ({
  panel,
  hideEditNav,
  hideReadNav,
  hideDeleteNav,
}: PanelSingleNavProps) => {
  const { panelDeleteMutate } = useSakusasPanelDelete({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_PANEL_SEARCH],
  });

  const actionConfirm = useConfirm();

  const deleteHandle = async () => {
    const check = await actionConfirm({
      title: "Panel",
      message: "Are you sure you want to delete panel",
    });
    if (check) {
      panelDeleteMutate(panel.id);
    }
  };

  return (
    <DivNav>
      {!hideDeleteNav && <DeleteIcon onClick={deleteHandle} />}
      {!hideEditNav && (
        <NavLink to={panelLinkSingle(panel.id, true)}>
          <EditIcon />
        </NavLink>
      )}
      {!hideReadNav && (
        <NavLink to={panelLinkSingle(panel.id)}>
          <ReadMoreIcon />
        </NavLink>
      )}
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 0.75rem;
  svg {
    margin-left: 1rem;
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
  &&& > svg:first-of-type {
    margin-left: 0;
  }
`;

export default PanelSingleNav;
